import { React, useState, useEffect } from "react";



function Aboutpage2() {
  const [isDeliveryBoyVisible, setDeliveryBoyVisible] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setDeliveryBoyVisible(window.innerWidth > 768);
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <section className="about-section padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="about-img-wrap">
                <img
                  className="wow fade-in-left"
                  data-wow-delay="100ms"
                  src="assets/img/content-bg-1.jpg"
                  alt="img"
                />
                <img
                  className="wow fade-in-bottom"
                  data-wow-delay="300ms"
                  src="assets/img/p.jpg"
                  alt="img"
                />
                <img
                  id="deliveryBoy"
                  src="https://img.freepik.com/premium-vector/young-woman-holding-laptop-with-empty-screen-pointing-finger-copy-space_535862-1473.jpg"
                  alt="img"
                  style={{
                    display: isDeliveryBoyVisible ? "block" : "none", // Use state for display
                  }}
                />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="section-heading mb-40">
                <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>Transforming IT Services with <span className="hl">Expertise and Excellence </span></h2>
                <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">
                  At <span style={{ color: '#0A0909', fontWeight: 'bold' }}>TITA Technologies</span>, we are more than just a tech company—we are your partners in innovation. From comprehensive <span style={{ color: '#0A0909', fontWeight: 'bold' }}>IT training programs </span> to expert staffing solutions and cutting-edge project management, we deliver results that redefine the future of technology. Our global footprint and deep-rooted industry knowledge enable us to tackle complex challenges and unlock new opportunities for businesses and individuals alike.
                </p>
              </div>
              <ul className="promo-list mb-30">
                <li className="wow fade-in-bottom" data-wow-delay="100ms">
                  <i className="fa-solid fa-lightbulb" />
                  <div className="promo-content">
                    <h3>Innovate Today</h3>
                    <p>Lead Tomorrow</p>
                  </div>
                </li>
                <li className="wow fade-in-bottom" data-wow-delay="300ms">
                  <i className="fa-solid fa-bullseye" />
                  <div className="promo-content">
                    <h3>Turn Ideas</h3>
                    <p>into Impact</p>
                  </div>
                </li>
                <li className="wow fade-in-bottom" data-wow-delay="300ms">
                  <i className="fa-solid fa-smile" />
                  <div className="promo-content">
                    <h3>Happy Clients</h3>
                    <p>Think Big</p>
                  </div>
                </li>
              </ul>
              <ul className="check-list mb-20 wow fade-in-bottom" data-wow-delay="100ms">
                <li><i className="fa-solid fa-check" /><b></b>Advanced tools for expert developers. Precision and efficiency at your fingertips.</li>
                <li><i className="fa-solid fa-check" /><b></b>Fair pricing for expert developers. Quality and value you can trust.</li>
                <li><i className="fa-solid fa-check" /><b></b>24/7 support for expert developers. Assistance whenever you need it.</li>
              </ul>
              <div className="btn-group wow fade-in-bottom" data-wow-delay="300ms">
                <div className="call-info">
                  <i className="fa-light fa-envelope-dot" />
                  <h3>Have Any Questions? <span>contact@titatechnologies.com</span></h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default Aboutpage2;
